import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/staff/")({
  head: () => ({
    meta: [{ title: "员工管理 · imiker CRM" }],
  })
});
